import { Alert as AlertComponent } from 'src/components/Alert';
import { useAlert } from './useAlert';

export const Alert = () => {
  const { alert, isAlertOpen, onCloseAlert } = useAlert();

  return (
    <AlertComponent
      isOpen={isAlertOpen}
      message={alert.message}
      onClose={onCloseAlert}
      title={alert.title}
      type={alert.type}
    />
  );
};
